(function ($, ko) {

    ko.bindingHandlers.chartFundingCalculator = {
        update: function (element, valueAccessor) {
            element.innerHTML = '<span class="spinner"><span></span> <span></span> <span></span></span>';
            
            const data = ko.unwrap(valueAccessor());
            if (!data) return;
            
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');

            const costs = data.Costs;
            const hsaBalance = data.HsaBalance;

            const max = Math.max(costs.LifeTime, hsaBalance.LifeTime);

            const labels = ['One Year', 'Five Years', 'Ten Years', 'Lifetime'];

            function moneyFormat(value) {
                return '$' + value.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
            }
            
            const config = {
                type: 'line',
                data: {
                    labels: labels,
                    datasets: [{
                        label: 'HSA Balance',
                        data: [hsaBalance.OneYear, hsaBalance.FiveYears, hsaBalance.TenYears, hsaBalance.LifeTime],
                        borderColor: "rgb(54, 162, 235)", //blue
                        backgroundColor: 'rgba(0, 0, 0, 0)',
                        fill: true,
                    }, {
                        label: 'Medical Costs',
                        data: [costs.OneYear, costs.FiveYears, costs.TenYears, costs.LifeTime],
                        borderColor: "rgb(255, 159, 64)", //orange
                        backgroundColor: 'rgba(0, 0, 0, 0)',
                        fill: true,
                    }]
                },
                options: {
                    responsive: true,
                    aspectRatio: $.cdh.isMobile ? 1 : 2,
                    tooltips: {
                        callbacks: {
                            label: function(tooltipItem, data) {
                                let label = data.datasets[tooltipItem.datasetIndex].label || '';

                                if (label) {
                                    label += ': ';
                                }
                                label += moneyFormat(tooltipItem.yLabel);
                                return label;
                            }
                        }
                    },
                    scales: {
                        xAxes: [{
                            display: true,
                            scaleLabel: {
                                display: true
                            }
                        }],
                        yAxes: [{
                            display: true,
                            ticks: {
                                min: 0,
                                suggestedMin: 0,
                                suggestedMax: max,
                                callback: function(value, index, values) {
                                    return  moneyFormat(value);
                                }
                            }
                        }]
                    }
                }
            };
            new Chart(ctx, config);
            element.innerHTML = '';
            element.appendChild(canvas);
        }
    };

})(jQuery, ko);